export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState) {
      var data = atob(serializedState);
      var temp = JSON.parse(data);

      return temp;
    } else {
      return undefined;
    }
  } catch (err) {
    return err;
  }
};
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (err) {
    throw err;
  }
};
